import AccountIconMUI from "@mui/icons-material/AccountBox";
import DescriptionIconMUI from "@mui/icons-material/Description";
import MessageIconMUI from "@mui/icons-material/Message";
import { Box, Button, Typography as TypographyMUI, styled, css } from "@mui/material";
import { rem } from "polished";

export const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$isAssociate",
})<{ $isAssociate: boolean }>`
  ${({ theme: { spacing, palette, breakpoints } }) =>
    css`
      padding: ${spacing(2)};
      margin: ${spacing(2)} ${spacing(5)} ${spacing(2)} ${spacing(25)};
      color: ${palette.tickets.nonAssociate};
      border-radius: ${spacing(1)};
      background-color: ${palette.common.white};
      box-shadow: ${palette.boxShadow};

      ${breakpoints.down("sm") &&
      css`
        margin: ${spacing(3)} ${spacing(0)} ${spacing(1)} ${spacing(3)};
      `}
    `};

  ${({ $isAssociate, theme: { spacing, breakpoints, palette } }) =>
    $isAssociate &&
    css`
      color: ${palette.tickets.associate};
      margin: ${spacing(2)} ${spacing(25)} ${spacing(2)} ${spacing(5)};

      ${breakpoints.down("sm") &&
      css`
        margin: ${spacing(3)} ${spacing(3)} ${spacing(1)} ${spacing(0)};
      `}
    `};
`;

export const Header = styled("div")`
  display: flex;
  justify-content: space-between;
`;

export const FirstTitle = styled("div")`
  display: flex;
  align-items: center;
`;

export const SecondTitle = styled("div")`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.palette.gray.main};
`;

export const Content = styled("div")`
  display: flex;
  background-color: ${(props) => props.theme.palette.tickets.contentBackground};
  margin: ${rem(15)};
  border-left: ${rem(3)} solid;
`;

export const DocumentContainer = styled("div")`
  margin-top: ${rem(20)};
`;

export const DocumentList = styled("div")`
  display: flex;
  flex-wrap: wrap;
  background-color: ${(props) => props.theme.palette.tickets.contentBackground};
  padding: ${rem(10)};
`;

export const Document = styled(Button)`
  color: ${(props) => props.theme.palette.gray.dark};
`;

export const Margin = styled("div")`
  margin: ${rem(5)};
`;

export const MobileDateContainer = styled("div")`
  display: flex;
  justify-content: flex-end;
  color: ${(props) => props.theme.palette.gray.dark};
  font-weight: bold;
  margin-top: ${rem(10)};
`;

export const Typography = TypographyMUI;

export const MessageIcon = MessageIconMUI;

export const AccountIcon = AccountIconMUI;

export const DescriptionIcon = DescriptionIconMUI;
